import { Img } from '@/components/blocks/MaterialImage';
import { Box } from '@mui/material';

interface OutfitImageProps {
	image: string;
}

export const OutfitImage: React.FC<OutfitImageProps> = ({ image }) => {
	return (
		<Box sx={{ display: 'flex' }}>
			<Img
				src={image}
				alt="Outfit"
				sx={{
					display: 'block',
					width: { xs: '100%', md: 'auto' },
					maxWidth: '100%',
					height: { xs: 'auto', md: '450px' },
					objectFit: 'cover',
					borderRadius: '4px',
				}}
			/>
		</Box>
	);
};
